import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { applyPublicCareer, getPublicCareer } from "../../api/recruitment";
import { validateAttachmentFile } from "../../api/attachments";
import {
  CareersShell,
  apiError,
  employmentTypeLabel,
} from "./CareersShell";
import JobApplyForm, { EMPTY_APPLY_FORM } from "./JobApplyForm";
import "./PublicCareers.css";

export default function PublicJobApply() {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState(EMPTY_APPLY_FORM);
  const [cvFile, setCvFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await getPublicCareer(id);
        if (!cancelled) setJob(data);
      } catch (err) {
        if (!cancelled) {
          setError(
            err?.response?.status === 403
              ? "بوابة التوظيف غير متاحة حالياً"
              : apiError(err, "الوظيفة غير متاحة"),
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id]);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    const fileError = validateAttachmentFile(cvFile);
    if (fileError) {
      setError(fileError);
      return;
    }
    setSubmitting(true);
    try {
      const payload = await applyPublicCareer(id, form, cvFile);
      setResult(payload);
    } catch (err) {
      setError(apiError(err, "تعذر إرسال الطلب"));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <CareersShell>
      <Link to="/careers" className="careers-back">
        ← كل الوظائف
      </Link>
      {loading && <div className="careers-status">جارٍ التحميل...</div>}
      {error && !job && <div className="careers-error">{error}</div>}
      {job && (
        <>
          <h1 className="careers-title">{job.title}</h1>
          <p className="careers-subtitle">
            {[job.department?.name, job.branch?.name, employmentTypeLabel(job.employmentType)]
              .filter(Boolean)
              .join(" · ")}
          </p>
          {(job.description || job.requirements) && (
            <div className="careers-job-body">
              {job.description ? (
                <>
                  <h3>الوصف</h3>
                  <p>{job.description}</p>
                </>
              ) : null}
              {job.requirements ? (
                <>
                  <h3>المتطلبات</h3>
                  <p>{job.requirements}</p>
                </>
              ) : null}
            </div>
          )}
          {result?.received ? (
            <div className="careers-success">
              <p>تم استلام طلبك بنجاح.</p>
              {result.reference ? (
                <>
                  <span>رقم المرجع</span>
                  <strong>{result.reference}</strong>
                </>
              ) : null}
              <Link to="/careers" className="careers-apply-btn">
                العودة للوظائف
              </Link>
            </div>
          ) : (
            <JobApplyForm
              form={form}
              setForm={setForm}
              cvFile={cvFile}
              setCvFile={setCvFile}
              onSubmit={handleSubmit}
              submitting={submitting}
              error={error}
            />
          )}
        </>
      )}
    </CareersShell>
  );
}
